import { MapPin, Waves, ArrowLeft, BedDouble, Bath, Maximize } from 'lucide-react';
import styles from './Header.module.css';

interface HeaderProps {
  propertyName: string;
  propertyAddress?: string;
  thumbnailUrl?: string | null;
  beds?: number | null;
  baths?: number | null;
  sqft?: number | null;
  onBack?: () => void;
}

export function Header({ 
  propertyName, 
  propertyAddress, 
  thumbnailUrl,
  beds,
  baths,
  sqft,
  onBack 
}: HeaderProps) {
  // Split address into street and city/state/zip
  const addressParts = propertyAddress?.split(',') || [];
  const streetAddress = addressParts.slice(0, 1).join('');
  const cityStateZip = addressParts.slice(1).join(',').trim();

  return (
    <header className={styles.header}>
      {onBack && (
        <button className={styles.backButton} onClick={onBack} aria-label="Go back">
          <ArrowLeft size={20} />
        </button>
      )}
      <div className={styles.logoContainer}>
        {thumbnailUrl ? (
          <img 
            src={thumbnailUrl} 
            alt={propertyName}
            className={styles.thumbnail}
          />
        ) : (
          <div className={styles.logo}>
            <Waves size={24} />
          </div>
        )}
        <div className={styles.titleContainer}>
          <h1 className={styles.title}>{propertyName}</h1>
          {propertyAddress && (
            <div className={styles.addressRow}>
              <MapPin size={14} />
              <span className={styles.address}>
                {streetAddress}<br />
                {cityStateZip}
              </span>
            </div>
          )}
          {(beds || baths || sqft) && (
            <div className={styles.statsRow}>
              {beds && (
                <span className={styles.stat}>
                  <BedDouble size={14} />
                  <span>{beds} {beds === 1 ? 'bed' : 'beds'}</span>
                </span>
              )}
              {baths && (
                <span className={styles.stat}>
                  <Bath size={14} />
                  <span>{baths} {baths === 1 ? 'bath' : 'baths'}</span>
                </span>
              )}
              {sqft && (
                <span className={styles.stat}>
                  <Maximize size={14} />
                  <span>{sqft.toLocaleString()} ft²</span>
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}


